import { render } from "./PanelCliente.vue?vue&type=template&id=3c2b96de&scoped=true"
import script from "./PanelCliente.vue?vue&type=script&lang=js"
export * from "./PanelCliente.vue?vue&type=script&lang=js"

import "./PanelCliente.vue?vue&type=style&index=0&id=3c2b96de&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2b96de"]])

export default __exports__